import { Dialog, DialogContent, IconButton } from '@mui/material';
import { Check, CircleDollarSign, X } from 'lucide-react';
import l from '../../../../../lang';
import './styles.scss';

interface PayoutCreatedDialogProps {
  open: boolean;
  beneficiaryName: string;
  onClose: () => void;
}

const PayoutCreatedDialog = ({ open, beneficiaryName, onClose }: PayoutCreatedDialogProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    PaperProps={{ className: 'payout-created-dialog' }}
  >
    <IconButton className="payout-created-dialog__close" aria-label={l('common.close')} onClick={onClose}>
      <X size={20} aria-hidden />
    </IconButton>
    <DialogContent className="payout-created-dialog__content">
      <span className="payout-created-dialog__icon" aria-hidden>
        <CircleDollarSign size={26} strokeWidth={1.75} />
        <span className="payout-created-dialog__icon-check">
          <Check size={12} strokeWidth={3} />
        </span>
      </span>
      <h2>{l('payouts.create.success.title')}</h2>
      <p>{l('payouts.create.success.body', beneficiaryName, l('payouts.create.success.serviceName'))}</p>
      <p>{l('payouts.create.success.helper')}</p>
      <span className="payout-created-dialog__more-info">{l('payouts.create.success.moreInformation')}</span>
    </DialogContent>
  </Dialog>
);

export default PayoutCreatedDialog;
